import { LmiContractConfig, QualificationType } from './types';

export const mdLmiContractConfig: LmiContractConfig = {
  title: 'Check if you qualify for income-based savings',
  description:
    'You may qualify for additional savings if your household income falls below a certain limit or if you participate in a qualifying low-income (LI) program.',
  lmiProofCategory: 'qualifying_programs',

  fields: [
    {
      name: 'county',
      type: 'select',
      label: 'County',
      required: true,
      placeholder: 'Select your county',
    },
    {
      name: 'householdOccupancy',
      type: 'select',
      label: 'Household occupancy',
      required: true,
      placeholder: 'Select an option',
    },
    {
      name: 'qualificationType',
      type: 'radio',
      label: 'Please select one of the options below:',
      header: 'Household income limit',
      description:
        "Based on your household size, your household's gross annual income limit is {incomeLimit}.",
      interpolations: {
        incomeLimit: {
          source: 'variable',
          variableName: 'incomeLimit',
        },
      },
      required: true,
      options: [
        {
          value: QualificationType.INCOME,
          label:
            "I attest that my household's annual income for the previous calendar year is less than the Federal household income limit to qualify as a low-income subscriber under the State of Maryland's Community Solar Energy Generating Systems Program.",
          enableWhen: {
            allOf: ['county', 'householdOccupancy'],
          },
        },
        {
          value: QualificationType.PROGRAM,
          label:
            'I attest that I am currently enrolled in and receive benefits from at least one of the following LI Qualifying Program(s):',
          listItems: [
            'Maryland Energy Assistance Program',
            'Supplemental Nutrition Assistance Program ("SNAP")',
            'Medicaid',
            'Headstart',
            'Section 8 Housing Choice Voucher Program',
            'Supplemental Security Income (SSI)',
            'Low-Income Household Water Assistance Program (LIHWAP)',
            'Temporary Assistance for Needy Families (TANF)',
            'Free and Reduced Meals',
            'Low Income Home Energy Assistance Program (LIHEAP)',
            'Maryland Housing Choice Voucher Program (HCVP)',
            'Social Security Disability Insurance (SSDI)',
            'Special Supplemental Nutrition Program for Women, Infants, and Children (WIC)',
            'Telephone lifeline service',
          ],
          enableWhen: {
            allOf: ['county', 'householdOccupancy'],
          },
        },
      ],
    },
  ],

  contractLink: {
    preText: 'I have reviewed my',
    postText: '. By proceeding, I will be submitting my e-signature on the',
  },
};
